import React, { useState } from "react";
import moment from "moment";
import { Table } from "antd";
import DocumentPreview from "../../components/popup/DocumentPreview";

const PaymentHistoryTable = ({ data, paymentHistory, onPaginationChange }) => {
  const [documentPreview, setDocumentPreview] = useState(false);
  const [fileDocumentType, setFileDocumentType] = useState("");
  const [previewType, setPreviewType] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");

  const fileType = (url) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];
    const documentExtensions = ["pdf", "doc", "docx", "txt", "rtf"];
    const lastDotIndex = url.lastIndexOf(".");
    if (lastDotIndex !== -1) {
      const fileExtension = url.slice(lastDotIndex + 1);
      if (imageExtensions.includes(fileExtension.toLowerCase())) {
        setFileDocumentType("Image");
      } else if (documentExtensions.includes(fileExtension.toLowerCase())) {
        setFileDocumentType("Document");
      }
    }
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "payment_date",
      key: "payment_date",
      render: (date) => (
        <span>{moment(date).format("DD-MM-YYYY")}</span>
      ),
    },
    {
      title: "Bonus Payable Amount",
      dataIndex: "paid_amount",
      key: "paid_amount",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
    },
    {
      title: "Document",
      dataIndex: "document_uploaded",
      key: "document_uploaded",
      render: (documentUrl) => (
        <div className="flex justify-start">
          <img
            src="/images/document_download.png"
            alt="Download Document"
            className="max-w-xs cursor-pointer"
            onClick={() => {
              fileType(documentUrl[0]?.value);
              setPreviewType(fileDocumentType);
              setPreviewUrl(documentUrl[0]?.value);
              setDocumentPreview(true);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <section className="table_section">
      <Table dataSource={paymentHistory} columns={columns} onChange={(value) => onPaginationChange(value)} />
      <DocumentPreview
        open={documentPreview}
        close={() => {
          setDocumentPreview(false);
        }}
        title={
          previewType.charAt(0).toUpperCase() +
          previewType.slice(1) +
          " Document"
        }
        url={previewUrl}
        type={fileDocumentType}
      />
    </section>
  );
};

export default PaymentHistoryTable;
